import { useCallback } from 'react';
import { useAppSettingsStore } from '@/shared/lib';
import { SUPPORTED_LANGUAGES } from '@/shared/config';
import type { Language } from '@/shared/types';
import { useGetRegistrationInfo, useSetRegistrationLanguage } from '../api';

let inFlightKey: string | null = null;

export function useRegistrationLanguageSync() {
  const { setLanguage } = useAppSettingsStore();
  const { setRegistrationLanguage } = useSetRegistrationLanguage();
  const { getRegistrationInfo } = useGetRegistrationInfo();

  const syncRegistrationLanguage = useCallback(
    async (state: string, preferredLanguage: Language) => {
      const key = `${state}:${preferredLanguage}`;
      if (inFlightKey === key) {
        return;
      }
      inFlightKey = key;

      try {
        await setRegistrationLanguage({ state, preferredLanguage });
        const info = await getRegistrationInfo(state);
        if (SUPPORTED_LANGUAGES.includes(info.preferredLanguage)) {
          setLanguage(info.preferredLanguage);
        }
      } catch {
        return;
      } finally {
        inFlightKey = null;
      }
    },
    [setRegistrationLanguage, getRegistrationInfo, setLanguage]
  );

  return { syncRegistrationLanguage };
}
